import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import {
    reopenTreasureBox
} from "../../store/partyChallenge/action";

const ReopenTreasureBox = (props) => {
    const [userId, setUserId] = useState("");
    const [errors, setError] = useState({});

    const handleSubmit = () => {
        let formIsValid = true;

        let errors = {};
        if (!userId) {
            formIsValid = false;
            errors["userId"] = "User ID is Required!";
        }
        if (!formIsValid) {
            setError(errors);
            return;
        } else {
            props.reopenTreasureBox(userId);
            setUserId("");
            setError({});
        }
    }

    return (
        <div>
            <div className="page-title">
                <div className="row">
                    <div className="col-12 col-md-6 order-md-1 order-last">
                        <h3 className="mb-3 text-white">Reopen Treasure Box</h3>
                    </div>
                    <div className="col-12 col-md-6 order-md-2 order-first">
                        <nav
                            aria-label="breadcrumb"
                            className="breadcrumb-header float-start float-lg-end"
                        >
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to="/admin/dashboard" className="text-danger">
                                        Dashboard
                                    </Link>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">
                                    Reopen Treasure Box
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <div className="modal-body pt-1 px-1 pb-3">
                <div className="d-flex flex-column">
                    <form>
                        <div className="row align-items-center">
                            <div className="col-md-6">
                                <label className="text-gray mb-2">Room Owner ID</label>
                                <input
                                    className="form-control"
                                    required=""
                                    placeholder="00000000"
                                    min="0"
                                    value={userId}
                                    onChange={(e) => {
                                        setUserId(e.target.value);
                                        if (!e.target.value) {
                                            return setError({
                                                ...errors,
                                                userId: "User ID is Required!",
                                            });
                                        } else {
                                            return setError({
                                                ...errors,
                                                userId: "",
                                            });
                                        }
                                    }}
                                />
                                {errors.userId && (
                                    <div className="ml-2 mt-1">
                                        {errors.userId && (
                                            <div className="pl-1 text__left">
                                                <span className="text-red">
                                                    {errors.userId}
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className={"mt-5 col-md-6"}>
                            <button
                                type="button"
                                className="btn btn-round float__right btn-danger"
                                onClick={handleSubmit}
                            >
                                Submit
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default connect(null, { reopenTreasureBox })(
    ReopenTreasureBox
);
